<script>
	const $ = require('jquery');
	const Vue = require('vue/dist/vue.js');
	const preloader = require('../../../components/preloader/preloader');
	const getOffsetTop = require('../../common/getOffsetTop');
	const portfolio = Vue.component('portfolio', {
		props: {
			url: {
				required: true
			}
		},
		data() {
			return {
				loadErrored: false,
				scrollBottom: 0,
				lastBoxYOffset: 0,
				scrollRequestCount: 2,
				ready: false,
				currentKey: "",
				data: {
					urls: {
						additional: ''
					},
					thatsAll: false,
					tabs: [],
					array: []
				}
			}
		},
		watch: {
			scrollBottom() {
				if (this.scrollBottom > this.lastBoxYOffset && this.ready) {
					this.getMore()
				}
			},
			ready() {
				if (this.ready) {
					preloader.remove()
				} else {
					preloader.init()
				}
			}
		},
		methods: {
			getLastBox() {
				return this.$refs.boxWrapper.children[this.data.array.length - 1]
			},
			cutLastBox() {
				const lastBox = this.getLastBox();
				let lastBoxItemFromBottom = '';
				let maxOffset = 0
				const items = lastBox.children;
				for (let item of items) {
					let thisMax = getOffsetTop(item) + item.offsetHeight;
					if (thisMax > maxOffset) {
						maxOffset = thisMax;
						lastBoxItemFromBottom = item
					}
				};
				lastBox.style.height = `${lastBoxItemFromBottom.offsetTop + lastBoxItemFromBottom.offsetHeight}px`
			},
			getMore(actionType, tab) {
				if (this.loadErrored) {
					return
				}
				let request = {
					PAGEN_1: 1,
				}
				if (actionType === "category") {
					window.location.hash = `#${tab.key}`
					this.currentKey = tab.key
					console.log(this.currentKey)
					tab.enabled = true;
					this.data.tabs.forEach(aTab => {
						if (tab.key !== aTab.key) {
							aTab.enabled = false
						}
					})
				} else {
					request.PAGEN_1 = this.scrollRequestCount;
				}
				if (this.currentKey !== "all") {
					request['key'] = this.currentKey
				}
				if (this.data.thatsAll && actionType !== 'category') {
					return
				};
				this.ready = false;
				$.ajax({
					url: this.data.urls.additional,
					data: request,
					type: 'get',
					dataType: "json",
					success: (data) => {
						if (actionType === "category") {
							Vue.set(this.data, 'array', [])
							this.scrollRequestCount = 2;
						} else {
							this.scrollRequestCount += 1;
						}
						this.data.thatsAll = data.thatsAll;
						this.data.array.push(data.array);
					},
					error: (xhr, status, err) => {
						this.$notie.alert({
							type: 'error',
							text: `Загрузка не удалась. Ошибка: ${err.toString()}. Мы уже решаем проблему ;)`,
							position: "bottom"
						});
						this.loadErrored = true;
					},
					complete: () => {
						setTimeout(() => {
							this.ready = true;
						},80)
					}
				})
			},
			setInitialStates() {
				let activeKey = this.currentKey
				this.data.tabs.forEach(tab => {
					if (tab.key === activeKey) {
						Vue.set(tab, 'enabled', true)
					} else {
						Vue.set(tab, 'enabled', false)
					}
				})
			}
		},
		beforeCreate() {
			preloader.init()
		},
		created() {
			if (window.location.hash.length) {
				this.currentKey =  window.location.hash.substr(1)
			} else {
				window.location.hash = "#all",
				this.currentKey = 'all'
			}
			let request = {}
			if (this.currentKey !== 'all') {
				request['key'] = this.currentKey
			}
			$.ajax({
				data: request,
				url: this.url,
				type: "get",
				dataType: "json",
				success: (data) => {
					Vue.set(this, 'data', data)
					this.setInitialStates()
				},
				error: (xhr, status, error) => {
					console.warn(xhr)
				}
			});
			this.scrollBottom = window.pageYOffset + window.innerHeight
			window.addEventListener('scroll', () => {
				this.scrollBottom = window.pageYOffset + window.innerHeight
			});
			let interval = setInterval( () => {
				if (this.$refs.boxWrapper && this.$refs.boxWrapper.children.length) {
					this.ready = true;
					clearInterval(interval)
				}
			}, 50);
		},
		updated() {
			const lastBox = this.getLastBox();
			this.lastBoxYOffset = parseInt(getOffsetTop(lastBox) + (lastBox.offsetHeight / 2), 10);
			if (this.data.thatsAll === true) {
				this.cutLastBox()
			} else {
				for (let item of this.$refs.boxWrapper.children) {
					item.setAttribute('style', '')
				}
			}
		}
	})
	module.exports = portfolio
</script>
<template>
	<div class='portfolio'>
		<div class='portfolio__plate'>
			<ul class='portfolio__tabs' v-if='data'>
				<li class='portfolio__tab-wrapper'
					v-for='(tab, index) in data.tabs'
					:key='index'>
					<div class='portfolio__tab'
						:class='{"portfolio__tab--active": tab.enabled}'
						@click='getMore("category", tab)'>
						{{tab.label}}
					</div>
				</li>
			</ul>
			<div class='portfolio__wrapper'
				v-if='data.array.length'
				ref='boxWrapper'>
				<div class="portfolio__box"
					v-for="(box, index) in data.array" :key='index'>
					<div class='portfolio__item'
						v-for="(item, idx) in box" :key='idx'>
						<client-case class='portfolio__case'
							:case-data='item' :index='idx'></client-case>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>